import { Controller } from "@hotwired/stimulus"

// seq-entry — one row of the generative-loop "Then cycle through" editor. The compact
// row chooses a type (Pattern / Word / Shape) + value; a collapsible "advanced" panel
// (toggled by ⋯) holds per-item Motion (size/spin/flip) and optional render overrides
// (particle style, connect, line width, thread — blank = inherit the global). The whole
// row is encoded into ONE hidden field as a JSON object so the pattern_sequence[] param
// + the live preview keep working unchanged.
export default class extends Controller {
  static targets = [
    "type", "patternValue", "textValue", "shapeValue",
    "size", "spin", "flip", "ps", "cn", "lw", "th",
    "patternField", "textField", "shapeField", "advanced", "encoded",
  ]

  connect() {
    this.toggle()
  }

  // type/value/override changed → show the right value input and re-encode.
  sync() {
    this.toggle()
    this.encode()
  }

  toggle() {
    const t = this.typeTarget.value
    if (this.hasPatternFieldTarget) this.patternFieldTarget.hidden = t !== "pattern"
    if (this.hasTextFieldTarget) this.textFieldTarget.hidden = t !== "text"
    if (this.hasShapeFieldTarget) this.shapeFieldTarget.hidden = t !== "shape"
  }

  toggleAdvanced() {
    if (this.hasAdvancedTarget) this.advancedTarget.hidden = !this.advancedTarget.hidden
  }

  encode() {
    const t = this.typeTarget.value
    const value = t === "text" ? this.textValueTarget.value.trim()
      : t === "shape" ? (this.hasShapeValueTarget ? this.shapeValueTarget.value : "")
        : this.patternValueTarget.value
    if (!value) {
      this.encodedTarget.value = ""
      this.notify()
      return
    }

    const h = { type: t, value }
    const sz = (this.hasSizeTarget ? parseInt(this.sizeTarget.value, 10) : 100) || 100
    const sp = (this.hasSpinTarget ? parseInt(this.spinTarget.value, 10) : 0) || 0
    const fl = (this.hasFlipTarget ? parseInt(this.flipTarget.value, 10) : 0) || 0
    if (sz !== 100) h.size = sz
    if (sp !== 0) h.spin = sp
    if (fl !== 0) h.flip = fl

    const ps = this.hasPsTarget ? this.psTarget.value : ""
    const cn = this.hasCnTarget ? this.cnTarget.value : ""
    const th = this.hasThTarget ? this.thTarget.value : ""
    const lw = this.hasLwTarget ? parseInt(this.lwTarget.value, 10) : NaN
    if (ps) h.ps = ps
    if (cn) h.cn = cn
    if (th) h.th = th
    if (lw > 0) h.lw = lw

    this.encodedTarget.value = JSON.stringify(h)
    this.notify()
  }

  // notify the live-preview controller (it listens for input on prefixed fields).
  notify() {
    this.encodedTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
